/* Copyright 2013 - 2024 Waiterio LLC */
/** @jsx jsx */
import React from 'react'
import { useParams } from 'react-router-dom'
import { jsx } from '@emotion/react'
import { useTranslation } from '@multilocale/react/index.js'
import allAreas from '@waiterio/takeaway/areas.js'
import SearchJumbotron from '@waiterio/takeaway/components/SearchJumbotron.js'
import locales from '../locales.js'

export const paths = locales.map(locale => ({
  path: `/takeaway/${locale}/city-:city`,
  props: {
    locale,
  },
}))

export const Head = ({ locale }) => {
  const { city } = useParams()
  let [language] = locale.split('-')
  const { t } = useTranslation(language)
  const cityName = city.charAt(0).toUpperCase() + city.slice(1)
  const title = `${t('Takeaway')} ${cityName} | Waiterio`
  const description = t('Takeaway from the best restaurants in {city}').replace(
    '{city}',
    cityName,
  )

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
    </>
  )
}

const CityPage = ({ locale }) => {
  const { city } = useParams()
  let [language] = locale.split('-')
  let areas = allAreas.filter(
    area => area.city.toLowerCase() === city.toLowerCase(),
  )
  const cityName = city.charAt(0).toUpperCase() + city.slice(1)

  return (
    <>
      <SearchJumbotron language={language} />
      <div css={{ textAlign: 'center' }}>
        <h1>Areas</h1>
        <div css={{ display: 'flex', flexWrap: 'wrap' }}>
          {areas.map(area => (
            <a
              key={area.name}
              href={`/takeaway/${locale}/area-${area.name.toLowerCase()}`}
              css={{ flexBasis: '25%', padding: 16 }}
            >
              {area.name} {cityName}
            </a>
          ))}
        </div>
      </div>
    </>
  )
}

export default CityPage
